/** @file scaleGizmo: the scale tool's one handle, the centre cube (uniform scale). */
import { GIZMO_METRICS as M } from './gizmoMetrics';
import type { GizmoShape } from './gizmoShape';
import { gizmoUnit } from './gizmoUnit';
import { unitSquare } from './unitSquare';

/** The centre cube (3), picked as a view-plane square `centreCube` wide; a key's `scale` is one number. */
export function scaleGizmo(): GizmoShape[] {
  const k = gizmoUnit(M.centreCube) / 2;
  return [{ axis: 3, frame: 'screen', lines: [], quads: [unitSquare(0, 1, [-k, k], [-k, k])] }];
}
